import { formatRemainingMmSs } from '@/helpers/duration';
import { cn } from '@/utils/cn';

export interface CountdownProps {
  remainingMs: number;
  warnMs: number;
  /** Already localized visible label, e.g. "Time remaining". */
  label: string;
  className?: string;
}

/**
 * Presentational. The single app-wide timer lives in `useCountdown` (Phase 3) so that two screens
 * cannot drift apart. This component never starts an interval.
 *
 * Digits are `aria-hidden`: announcing every second makes the page unusable with a screen reader.
 * Coarse milestones go through the live region, owned by the hook, not by this display.
 */
export function Countdown({ remainingMs, warnMs, label, className }: CountdownProps) {
  const urgent = remainingMs <= warnMs;
  const display = formatRemainingMmSs(remainingMs);

  return (
    <div
      className={cn(
        'inline-flex min-w-0 items-baseline gap-2 tabular-nums',
        urgent ? 'text-danger' : 'text-text',
        className,
      )}
    >
      <span className={cn('text-sm', urgent ? 'text-danger' : 'text-text-muted')}>{label}</span>
      <span aria-hidden="true" className="font-semibold">
        {display}
      </span>
    </div>
  );
}
